export const generateTemporaryNumberId = ({ createdIds }: { createdIds: Set<number> }): number => {
  let id = -Math.floor(Math.random() * 1000000);
  while (createdIds.has(id)) {
    id = -Math.floor(Math.random() * 1000000);
  }
  return id;
};
